$(document).ready(function() {
  if (navigator.userAgent.indexOf('Mac OS X') != -1) {
  $("body").addClass("mac");
} else {
  $("body").addClass("win");
}
	 $('#main_slider').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: false,
		  fade: true,
		//  dots:false,
		  autoplay: true,
		  asNavFor: '#thumbnail_slider'
	});
	$('#thumbnail_slider').slick({
		  slidesToShow: 3,
		  slidesToScroll: 1,
		  asNavFor: '#main_slider',
		  autoplay: true,
		  dots: false,
		  vertical: true,
		  //centerMode: true,
		  focusOnSelect: true
	});
  $('#logo_slider').slick({
		  slidesToShow: 4,
		  slidesToScroll: 1,
		  autoplay: true,
		  dots: false,
		  vertical: false,
          prevArrow:'',
          nextArrow:'',
		  centerMode: false,
		  //focusOnSelect: true
	});
   $('#home_bottom_img').slick({
		dots: false,
     arrows: false,
		infinite: true,
		speed: 700,
		autoplay: true,
  		autoplaySpeed: 2000,
	});
	$('.mt-slide_nav').click(function() {
	//	alert ('click');
		$('.slick-next').trigger('click');
	});
	$("#mt-main_slider").owlCarousel({
        nav: false,
		dots : true,
		items: 1,
		loop: true,
        navText: [
        "<i class='mdi mdi-chevron-left'></i>",
        "<i class='mdi mdi-chevron-right'></i>"
        ],

      });
	  $('#mt-brands_carousel').owlCarousel({
		autoPlay: 6000, //Set AutoPlay to 3 seconds
 		dots:false,
		nav: true,
		loop:true,
      	responsive:{
			0:{
				items:1,
				nav:true
			},
			470:{
				items:2,
				nav:false
			},
			768:{
				items:3,
				nav:false
			},
			1000:{
				items:4,
				nav:true,
			}
    	},
	  	navText: [
        	"<i class='mdi mdi-chevron-left'></i>",
        	"<i class='mdi mdi-chevron-right'></i>"
        ],
	});
	
	$('#mt-video_slider1').owlCarousel({
		nav: true,
		dots : false,
		items: 1,
		loop: true,
		video: true,
        navText: [
        "<i class='mdi mdi-chevron-left'></i>",
        "<i class='mdi mdi-chevron-right'></i>"
        ],

	});
	$("#mt-product_slider").owlCarousel({
        nav: false,
		dots : true,
		items: 1,
		loop: true,
		dotsEach: true,
        navText: [
        "<i class='mdi mdi-chevron-left'></i>",
        "<i class='mdi mdi-chevron-right'></i>"
        ],
      });
	  var i = 1, total = $('#pager a').length;
		$('#mt-product_slider .owl-dots>div').each(function(){
		  $(this).text(i);
		  i++;
	});
	$('.mt-product_thumb .mt-thumb').click(function() {
		var clickThumb = $(this).attr('data-number');
		$('.owl-dots div:nth-child('+clickThumb+')').trigger('click');
	});
	$('.mt-newsletter a').click(function(e) {
		e.preventDefault();
		$('.mt-overlay_dark, .mt-popop').fadeIn(300);
	});
	$('.mt-overlay_dark, .mt-close').click(function() {
		$('.mt-overlay_dark, .mt-popop').fadeOut(300);
	});
	// mobile menu
	
	$('.mt-toggle').click(function() {
		$(this).toggleClass('mt-open');
		$('body').toggleClass('mt-nav_open');
		$('#mt-mobile_navigation').fadeToggle(300);
	});
	$('.mt-sub_toggle').click(function() {
		$(this).toggleClass('mt-open').next('ul').slideToggle(300);
	});

	//tab
	$('.mt-tab_header a').click(function(e) {
		e.preventDefault();
		var currentTab = $(this).attr('href');
		var dataTab = $(this).parents('.mt-tab').attr('id');
		$(this).parent().siblings('.mt-tab_header li').removeClass('mt-active');
		$(this).parent().addClass('mt-active');
		$(this).parents('.mt-tab').children('div').attr('data-parent', dataTab).hide();
		$(currentTab).fadeIn();
		//alert(dataTab);
	});
	
	//filter recipe 
	$(document).on('click', '.mt-toggle_filter', function() {
		$(this).next('ul').slideToggle();
	});
	
	$(document).on('click', '.mt-filter_content ul', function(e) {
		$(this).slideUp();
		
	});
	
	function slideWidth() {
		var slideW = $('#main_slider').parents('.col-xs-12').width();
		$('.mt-slides').width(slideW);
	}
	slideWidth();
	
	$(window).resize(slideWidth);
	
	// go to top
	$('.mt-go_top').click(function(e) {
		e.stopPropagation();
		$('html, body').animate({
			scrollTop: 0
		},500, 'easeInCubic')
		return false;
	});
	$('.mt-sidebar_widget .mt-widget_title:first-child').next().show();
	$('.mt-sidebar_widget .mt-widget_title:last').css('border', 'none');
	$('.mt-sidebar_left .mt-widget_title').click(function(e) {
		if($(this).hasClass('expand')) {
			$(this).next('ul').slideUp(500);
			$('.mt-sidebar_widget .mt-widget_title').removeClass('expand');
			e.stopPropagation();
		} else {
			$('.mt-widget_title').removeClass('expand');
			$(this).addClass('expand');
			$('.mt-sidebar_widget .mt-widget_title').next('ul').slideUp(500);
			$(this).next('ul').slideToggle(500);
			e.stopPropagation();
		}
	}); 
 var random = Math.floor(Math.random() * 1000);

var $li = $(".mt-tab_header li");
  var $tab = $('.mt-tab_content');
$li.eq(random % $li.length).addClass("mt-active");
    $tab.eq(random % $tab.length).show();	
});

//equalheight start
        
    var equalheight = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto');
  var topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
};

$(window).load(function() {
  equalheight('.equal_height');
});


$(window).resize(function(){
  equalheight('.equal_height');
});

$(window).resize(function() {
		var winWidth = $(window).width();
		if($(winWidth > 959)) {
			$('.mt-foot_menu_title').next().removeAttr('style');
		if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
 // some code..
        }else{	
          $('#mt-mobile_navigation').removeAttr('style');
			$('.mt-toggle').removeClass('mt-open');
			$('body').removeClass('mt-nav_open');
		}
        }
});
